module.exports = __webpack_public_path__ + "static/people-0fcd5184675d1ad9053e587c80fb4516.png";